import { render } from "./App.vue?vue&type=template&id=dcdb694c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dcdb694c&lang=css"
script.render = render

export default script